import { Edit } from "@mui/icons-material";
import classNames from "classnames";
import React from "react";
import Button from "../../atoms/Button/Button";

interface CardProps {
  title: string;
  editable?: boolean;
  className?: string;
  children: React.ReactNode;
  additionalActions?: React.ReactNode;
  onEdit?: () => void;
}

const Card = (props: CardProps) => {
  const { title, editable, children, className, additionalActions, onEdit } =
    props;
  const currClassName = classNames("dui-card", className);
  return (
    <div className={currClassName}>
      <div className="dui-card-title">
        {title}
        <div className="dui-card-title-actions">
          {additionalActions}
          {editable && <Button icon={<Edit />} onClick={onEdit} type="text" />}
        </div>
      </div>
      <div className="dui-card-content">{children}</div>
    </div>
  );
};

export default Card;
